<form *ngIf="auditTrailEnabled" [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-select disableOptionCentering
      test-id="delete-reason-select"
      formControlName="deleteReason"
      placeholder="{{ 'fwDeleteReason.placeholder' | translate }}"
      (selectionChange)="onChangeReason()">
      <mat-option>{{ 'fwDeleteReason.default' | translate }}</mat-option>
      <mat-option *ngFor="let deleteReason of deleteReasons" [value]="deleteReason.key">
        {{ deleteReason.value | titlecase }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!isCompact">{{ 'fwDeleteReason.required' | translate }}</mat-error>
  </mat-form-field>
  <mat-icon *ngIf="isCompact && form.touched && form.invalid" class="red xs" matTooltip="{{ 'fwDeleteReason.required' | translate }}" matTooltipPosition="above">error</mat-icon>
</form>
